import React from 'react';

interface NmTagProps {
  children: React.ReactNode;
  variant?: 'neutral' | 'success' | 'danger' | 'warning' | 'info' | 'pink';
  dot?: boolean;
  icon?: React.ReactNode;
  className?: string;
}

/** Neumorphic badge/tag in 6 semantic variants. */
export function NmTag({
  children,
  variant = 'neutral',
  dot = false,
  icon,
  className = '',
}: NmTagProps) {
  return (
    <span className={`nm-tag nm-tag--${variant} ${className}`}>
      {dot && (
        <span
          style={{
            width: 5,
            height: 5,
            borderRadius: '50%',
            background: 'currentColor',
            flexShrink: 0,
          }}
        />
      )}
      {icon}
      {children}
    </span>
  );
}
